export default __webpack_public_path__ + "static/media/spinner.75aa1245.svg";